import { render, staticRenderFns } from "./DetailsCourseAssignWordModal.vue?vue&type=template&id=680e0b7f&scoped=true&"
import script from "./DetailsCourseAssignWordModal.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseAssignWordModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e0b7f",
  null
  
)

export default component.exports